import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const NoOption = ({ hidden }) => {
  const { t } = useTranslation()
  if (hidden) {
    return null
  }

  return (
    <div style={{ textAlign: 'center', marginTop: '1rem' }}>
      {t('subscriptionForm:contract_modal.no_authorized_business_vertical')}
    </div>
  )
}

NoOption.propTypes = {
  hidden: PropTypes.bool,
}

export default NoOption
